export const sizes = {
    oldContainerWidth: {
        // It's deprecated and will be removed after redesign (used in checkout)
        value: '100rem',
    },
    containerWidth: {
        value: '1320px',
    },
    mapSidebarWidth: {
        value: '300px',
    },
    drawerWidthLg: {
        value: '1020px',
    },
};
